import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { Accordion } from "ui/gluestack/accordion";
import { Text, View } from "react-native";
import Pagination from "ui/molecules/pagination/Pagination";
import { AssessmentAccordionPreview } from "app/features/reporting/organisms/AssessmentAccordionPreview";
import { useFormHistoryWithOffline } from "app/features/offline/hooks/useFormHistoryWithOffline";
import { useMemo } from "react";

interface Props {
  tag: FormEnums;
  residentId: number;
  excludeEntryId: number;
}
export function AssessmentVersionedHistoryTemplate({
  tag,
  residentId,
  excludeEntryId,
}: Props) {
  const { data, meta, isLoading, handlePageChange } = useFormHistoryWithOffline(
    { tag, residentId },
  );

  const filteredData = useMemo(() => {
    return data?.filter((item) => item.id !== excludeEntryId);
  }, [data, excludeEntryId]);

  if (!filteredData?.length) return null;
  return (
    <View>
      <View>
        <Text className="text-md font-semibold mb-2">Versions</Text>
      </View>
      <Accordion type="single" variant="filled" className="mb-4">
        {filteredData?.map((item) => (
          <AssessmentAccordionPreview form={item} key={item.id} versioned />
        ))}
      </Accordion>
      {meta && meta?.last_page > 1 && (
        <Pagination meta={meta} onPageChange={handlePageChange} />
      )}
    </View>
  );
}
